import { render, staticRenderFns } from "./BeefPolicyForm.vue?vue&type=template&id=42e8fd91"
import script from "./BeefPolicyForm.vue?vue&type=script&lang=js"
export * from "./BeefPolicyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports